module.exports = __webpack_public_path__ + "img/diploma_3.70b88548.jpg";